/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
window.gtmPageType = window.ShopifyAnalytics?.meta?.page?.pageType;
function gaEvtPub(evt, obj) {
  Shopify.analytics.publish(evt, obj);
  // console.log('oblog', evt, JSON.stringify(obj));
}
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  const spo = window.Shopify || {};
  const current = {
    lang: spo.locale,
    rgcu: spo.country + '_' + (spo.currency?.active || ''),
  };
  const trackChange = (key, newVal, eventName) => {
    const oldVal = sessionStorage.getItem(key);
    if (newVal && newVal !== oldVal) {
      sessionStorage.setItem(key, newVal);
      if (oldVal) {
        gaEvtPub('sce_navigation', {
          event: 'dle_navigation',
          event_name: eventName,
          event_parameters: { button_name: `${oldVal}>${newVal}` },
        });
      }
    }
  };
  trackChange('gast_lang', current.lang, 'select_language');
  trackChange('gast_rgcu', current.rgcu, 'select_currency');
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  window.gtm_vobj = window.gtm_vobj || {};
  var scrollThresholds = [0.75];
  gtm_vobj.scrollTriggered = gtm_vobj.scrollTriggered || {};
  var throttleTimeout;
  function onScroll() {
    if (throttleTimeout) return;
    throttleTimeout = setTimeout(function () {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (!docHeight || docHeight <= 0) {
        throttleTimeout = null;
        return;
      }
      var scrollPercent = scrollTop / docHeight;
      for (var i = 0; i < scrollThresholds.length; i++) {
        var threshold = scrollThresholds[i];
        if (!gtm_vobj.scrollTriggered[threshold] && scrollPercent >= threshold) {
          gtm_vobj.scrollTriggered[threshold] = true;
          gaEvtPub('sce_scroll', {
            event: 'dle_scroll',
            event_name: 'scroll',
            event_parameters: {
              percent_scrolled: Math.round(threshold * 100),
            },
          });
        }
      }
      var allTriggered = true;
      for (var j = 0; j < scrollThresholds.length; j++) {
        if (!gtm_vobj.scrollTriggered[scrollThresholds[j]]) {
          allTriggered = false;
          break;
        }
      }
      if (allTriggered) {
        window.removeEventListener('scroll', onScroll);
      }

      throttleTimeout = null;
    }, 100);
  }
  window.addEventListener('scroll', onScroll);
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  var eleQuickSearch = document.querySelector('a.thb-quick-search');
  if (eleQuickSearch) {
    eleQuickSearch.addEventListener('click', function (event) {
      gaEvtPub('dle_search_btn_click');
    });
  }
})();
(function () {
  var eleSearchDrawer = document.getElementById('Search-Drawer');
  if (eleSearchDrawer) {
    eleSearchDrawer.addEventListener('click', function (event) {
      var a = event.target.closest('a');
      if (a && a.className.includes('thb-predictive-search--query')) {
        var inputStr = document.querySelector('#search-drawer--searchform-input')?.value?.trim() || '';
        gaEvtPub('sce_search_suggest_click', {
          search_term: a.textContent.trim(),
          search_input: inputStr,
        });
      }
    });
  }
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  var eleViewCart = document.querySelector('a.thb-secondary-cart');
  if (eleViewCart) {
    eleViewCart.addEventListener('click', function (event) {
      gaEvtPub('sce_view_cart');
    });
  }
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  var fullMenu = document.querySelector('.full-menu');
  if (fullMenu) {
    fullMenu.addEventListener('click', function (e) {
      const target = e.target.closest('a');
      if (!target) return;
      const menuNames = [];
      const title = target.getAttribute('title') || (target.innerText || '').trim();
      menuNames.unshift(title);
      const currentPanel = target.closest('.full-menu--subpanel');
      if (currentPanel) {
        const parentLink = document.querySelector(`.full-menu [data-target="#${currentPanel.id}"]`);
        if (parentLink) {
          menuNames.unshift(parentLink.getAttribute('title') || (parentLink.innerText || '').trim());
          const parentPanel = parentLink.closest('.full-menu--subpanel');
          if (parentPanel) {
            const grandParentLink = document.querySelector(`.full-menu--menu-primary [data-target="#${parentPanel.id}"]`);
            if (grandParentLink) {
              menuNames.unshift(grandParentLink.getAttribute('title') || (grandParentLink.innerText || '').trim());
            }
          }
        }
      }
      const [first_nav, second_nav, third_nav] = menuNames;
      gaEvtPub('sce_navigation', {
        event: 'dle_navigation',
        event_name: 'top_navigation',
        event_parameters: {
          first_nav: first_nav,
          second_nav: second_nav,
          third_nav: third_nav,
        },
      });
    });
  }
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  document.querySelectorAll('#footer .widget--menu-column .thb-widget-menu a').forEach(function (item) {
    item.addEventListener('click', function () {
      var firstNav = this.closest('.widget--menu-column')?.querySelector('button.thb-widget-title')?.textContent?.trim() || '';
      gaEvtPub('sce_navigation', {
        event: 'dle_navigation',
        event_name: 'bottom_navigation',
        event_parameters: {
          first_nav: firstNav,
          second_nav: this.textContent.trim(),
        },
      });
    });
  });
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  document.querySelectorAll('.announcement-bar .announcement-bar--carousel .announcement-bar--item').forEach(function (item) {
    item.addEventListener('click', function () {
      gaEvtPub('sce_notice', {
        event: 'dle_notice',
        event_name: 'top_notice',
        event_parameters: {
          button_name: this.textContent.trim(),
        },
      });
    });
  });
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  if (window.gtmPageType !== 'home') return;
  document.querySelectorAll('.main-slideshow .slideshow__slide .slideshow__slide-inner').forEach(function (item, index) {
    item.addEventListener('click', function () {
      var pnode = this.closest('.slideshow__slide');
      var ahref = (pnode?.querySelector('a.slideshow__slide-content-link')?.getAttribute('href') || '').split('/').pop();
      var videoSrc = '';
      var firstSource = pnode?.querySelector('.slideshow__slide-adapt-to-image img');
      if (firstSource) {
        videoSrc = (firstSource.getAttribute('src') || '').split('/').pop().split('?')[0];
      }
      gaEvtPub('sce_select_promotion', {
        event: 'dle_select_promotion',
        event_name: 'select_promotion',
        event_parameters: {
          promotion_id: ahref,
          promotion_name: 'home_top_banner_' + (index + 1),
          creative_name: videoSrc,
        },
      });
    });
  });
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  if (window.gtmPageType !== 'collection') return;
  const getFilterInfo = () => {
    const params = new URLSearchParams(location.search);
    const types = [];
    const values = [];
    for (const [key, value] of params) {
      if (key.startsWith('filter.')) {
        types.push(key.split('.').pop());
        values.push(value);
      }
    }
    gaEvtPub('sce_select_content', {
      event: 'dle_select_content',
      event_name: 'select_content',
      event_parameters: {
        content_type: types.join('&'),
        content_id: values.join('&'),
      },
    });
  };
  let prevSearch = '';
  const checkSearch = () => {
    const { search } = location;
    if (search.includes('sort_by=manual') && search !== prevSearch) {
      getFilterInfo();
    }
    prevSearch = search;
  };
  window.addEventListener('DOMContentLoaded', checkSearch);
  ['pushState', 'replaceState'].forEach((fn) => {
    const original = history[fn];
    history[fn] = function (...args) {
      const result = original.apply(this, args);
      checkSearch();
      return result;
    };
  });
  window.addEventListener('popstate', checkSearch);
  /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
  document.querySelectorAll('.shopify-section .custom-content button.readmore-trigger1').forEach(function (item) {
    item.addEventListener('click', function () {
      gaEvtPub('sce_read_more', {
        event: 'dle_read_more',
        event_name: 'read_more',
        event_parameters: {
          button_name: 'Read More',
        },
      });
    });
  });
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  if (window.gtmPageType !== 'collection') return;
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      gaEvtPub('sce_sort_usage', {
        event: 'dle_sort_usage',
        event_name: 'sort_usage',
        event_parameters: {
          button_name: this.options[this.selectedIndex].text,
        },
      });
    });
  }
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  if (window.gtmPageType !== 'collection') return;
  var item_click = function (itemId, itemNm) {
    gaEvtPub('sce_select_item', {
      event: 'dle_select_item',
      event_name: 'select_item',
      event_parameters: {
        itemId: itemId,
        itemNm: itemNm,
      },
    });
  };
  document.querySelectorAll('.collection-container .product-card a>img').forEach(function (item) {
    item.addEventListener('click', function () {
      var itemId = this.closest('.product-card')?.querySelector('.product-card-quickview')?.getAttribute('data-product-id');
      var itemNm = this.closest('.product-card')?.querySelector('.product-card-info .product-card-title')?.getAttribute('title');
      item_click(itemId, itemNm);
    });
  });
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  document.querySelectorAll('.signup-container button.submit').forEach(function (btn) {
    btn.addEventListener('click', function () {
      gaEvtPub('sce_subscription', {
        event: 'dle_subscription',
        event_name: 'subscription',
        event_parameters: {
          status: 'unknown',
        },
      });
    });
  });
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  document.querySelectorAll('.social-links a.social').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var buttonName = this.getAttribute('title');
      gaEvtPub('sce_share', {
        event: 'dle_share',
        event_name: 'share',
        event_parameters: {
          button_name: buttonName,
        },
      });
    });
  });
})();
(function () {
  if (window.gtmPageType !== 'page') return;
  document.querySelectorAll('.blog-post-detail .gw-wl-social-share .gw-wl-social-share__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var buttonName = this.getAttribute('class')
        .replace('gw-wl-social-share__btn', '')
        .match(/__([a-z-]+)-btn/);
      if (buttonName) buttonName = buttonName[1];
      gaEvtPub('sce_share', {
        event: 'dle_share',
        event_name: 'share',
        event_parameters: {
          button_name: buttonName,
        },
      });
    });
  });
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  var eleLiveChat = document.querySelector('#custom-quickcep-launcher button');
  eleLiveChat?.addEventListener('click', function () {
    gaEvtPub('sce_customer_service', {
      event: 'dle_customer_service',
      event_name: 'customer_service',
      event_parameters: {
        button_name: 'live chat',
      },
    });
  });
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
(function () {
  if (window.gtmPageType !== 'product') return;
  /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
  const tabWrapper = document.querySelector('.tabbed-content--tabs');
  if (tabWrapper) {
    tabWrapper.addEventListener('click', function (event) {
      const btn = event.target.closest('button');
      if (btn) {
        var btnNm = (btn.innerText || '').trim();
        gaEvtPub('sce_detail_click', {
          event: 'dle_detail_click',
          event_name: 'detail_click',
          event_parameters: {
            button_name: btnNm,
          },
        });
      }
    });
  }
  /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
  document.querySelectorAll('.product-information .side-panel-links').forEach(function (ele) {
    ele.addEventListener('click', function (event) {
      var btn = event.target.closest('.side-panel-links--link');
      if (!btn) return;

      var btnNm = (btn.innerText || '').trim();
      console.log('sce_detail_click payload', {
  event: 'dle_detail_click',
  event_name: 'detail_click',
  event_parameters: {
    button_name: btnNm,
  },
});
      gaEvtPub('sce_detail_click', {
        event: 'dle_detail_click',
        event_name: 'detail_click',
        event_parameters: {
          button_name: btnNm,
        },
      });
    });
  });
})();
(function () {
  document.addEventListener('click', function (e) {
    try {
      const productCard = e.target.closest('#product-grid-predictive-search .product-card');
      if (productCard) {
        var inputStr = document.querySelector('#search-drawer--searchform-input')?.value?.trim() || '';
        gaEvtPub('sce_search_product_click', {
          event: 'dle_search',
          event_name: 'search',
          event_parameters: {
            search_term: inputStr,
            search_input: inputStr,
            search_type: 'product_click',
          },
        });
      }
    } catch (err) {}
    /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
    if (window.gtmPageType == 'product') {
      try {
        var navBtn = e.target.closest('.product-recommendations .flickity-nav');
        if (navBtn) {
          var btnClass = navBtn.getAttribute('class') || '';
          var btnType = btnClass.includes('prev') ? 'left' : 'right';
          var btnNm = 'pairs well with_' + btnType;
          gaEvtPub('sce_tab_click', {
            event: 'dle_tab_click',
            event_name: 'tab_click',
            event_parameters: {
              button_name: btnNm,
            },
          });
        }
        /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
        const recItem = e.target.closest('.product-recommendations .product-cart-item');
        if (recItem) {
          gaEvtPub('sce_recItem_click');
        }
        /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
        const btn = e.target.closest('.main-product-page .gw-add-to-wishlist-product-card-placeholder button.gw-toggle-wishlist-product-card-button');
        if (btn) {
          const container = btn.closest('.gw-add-to-wishlist-product-card-placeholder');
          const itemId = container ? container.getAttribute('data-gw-product-id') : null;
          const type = btn.getAttribute('data-in-wishlist') === 'true' ? 'remove' : 'add';
          if (type === 'add') {
            gaEvtPub('sce_add_to_wishlist', {
              event: 'dle_add_to_wishlist',
              event_name: 'add_to_wishlist',
              event_parameters: { itemId: itemId },
            });
          } else {
            gaEvtPub('sce_remove_from_wishlist', {
              event: 'dle_remove_from_wishlist',
              event_name: 'remove_from_wishlist',
              event_parameters: { item_id: itemId },
            });
          }
        }
      } catch (err) {}
    }
    /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
    if (e.target.classList?.contains('order-note-toggle')) {
      try {
        var btnNm = (e.target.innerText || '').trim();
        gaEvtPub('sce_add_order_note', {
          event: 'dle_add_order_note',
          event_name: 'add_order_note',
          event_parameters: {
            button_name: btnNm,
          },
        });
        /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
        if (!window.gtmFlag_noteSave) {
          var miniCartNote = document.querySelector('#mini-cart-note button');
          if (miniCartNote) {
            miniCartNote.addEventListener('click', function (ie) {
              var btnName = (ie.target.innerText || '').trim();
              gaEvtPub('sce_add_order_note', {
                event: 'dle_add_order_note',
                event_name: 'add_order_note',
                event_parameters: {
                  button_name: btnName,
                },
              });
            });
            window.gtmFlag_noteSave = true;
          }
        }
      } catch (err) {}
    }
    /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
    if (window.gtmPageType == 'page' && location.pathname == '/pages/wishlist') {
      try {
        const wishItem = e.target.closest('.gw-wl-page-list .gw-wl-page-item .gw-wl-page-item__delete-btn');
        if (wishItem) {
          var itemId = wishItem.closest('.gw-wl-page-item').getAttribute('data-gw-product-id');
          var itemName = wishItem.closest('.gw-wl-page-item').querySelector('.gw-wl-page-item__title')?.innerText || '';
          gaEvtPub('sce_remove_from_wishlist', {
            event: 'dle_remove_from_wishlist',
            event_name: 'remove_from_wishlist',
            event_parameters: {
              item_id: itemId,
              item_name: itemName,
            },
          });
        }
      } catch (err) {}
    }
  });
  if (location.pathname == '/pages/joy-loyalty-page') {
    document.addEventListener(
      'click',
      function (e) {
        try {
          /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
          const redeemBtn = e.target.closest('.Joy-Redeem__DirectButton');
          if (redeemBtn) {
            var pnode = redeemBtn.closest('.Joy-Redeem__Item');
            var info = pnode?.querySelector('.Joy-Redeem__Item-Title')?.innerText || '';
            var points = (pnode?.querySelector('.Joy-Way-To-Redeem__Item-SubTitle')?.innerText || '').replace(/\D/g, '');
            gaEvtPub('sce_account_click', {
              event: 'dle_account_click',
              event_name: 'account_click',
              event_parameters: {
                button_name: 'redeem',
                info: info,
                points: points,
              },
            });
          }
        } catch (err) {}
      },
      true,
    );
  }
})();
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
